// extracted by mini-css-extract-plugin
export default {"wrapper":"QB-z","button":"RB-z","alternate":"SB-z","disabled":"TB-z","paymentWarning":"UB-z","fadeIn":"VB-z"};